import {
    BANNED_ACCOUNT,
    HANDLE_ERRORS,
    HANDLE_VALIDATION_ERRORS,
    SET_ERROR_STATUS_CODE,
    SET_VALIDATION_ERRORS
} from "@/core/store/modules/errors/constants";
import toast from "@/core/utils/toast";
import VueCookies from "vue-cookies";
import router from '@/core/services/router.service'
import store from "@/core/store";
import {DESTROY_TOKEN} from "@/core/store/modules/auth/constants";
import {DESTROY_ACCOUNT} from "@/core/store/modules/account/constants";

export default {
    [HANDLE_ERRORS](context, {error}) {
        if (typeof error.response == "undefined" || typeof error.response.status == "undefined") {
            store.commit(SET_ERROR_STATUS_CODE, 503)
            router.push({
                name: "errors.unavailable"
            }).catch((error) => {
            })
        }

        if (error.response.status) {
            store.commit(SET_ERROR_STATUS_CODE, error.response.status)
        }

        if (error.response.data.success === false && error.response.data.message) {
            toast.error(error.response.data.message)
        }


        if (error.response.status === 401 && error.response.data.redirect !== false) {
            store.commit(DESTROY_TOKEN)
            store.commit(DESTROY_ACCOUNT)
            router.push({
                name: "login"
            }).catch((error) => {
            })
        }

        if (error.response.status === 403) {
            router.push({
                name: "errors.forbidden"
            }).catch((error) => {
            })
        }


        if (error.response.status === 404 && error.response.data.redirect === true) {
            router.push({
                name: "errors.not_found"
            }).catch((error) => {
            })
        }

        if (error.response.status === 429) {
            if (!error.response.data.message) {
                toast.error('درخواست های زیادی از سمت شما ارسال شده است . لطفا دقایقی دیگر امتحان کنید')
            }

            if (error.response.data.seconds) {
                VueCookies.set('banned', error.response.data.unblocking_at, `${error.response.data.seconds}s`)
                router.push({
                    name: "errors.banned"
                }).catch((error) => {
                })
            }

        }

        if (error.response.status === 500) {
            router.push({
                name: "errors.internal_server_error"
            }).catch((error) => {
            })
        }

    },

    [HANDLE_VALIDATION_ERRORS](context, {error, form}) {
        if (error.response.data.errors) {
            context.commit(SET_VALIDATION_ERRORS, {errors: error.response.data.errors, form: form})
        }
    },

    [BANNED_ACCOUNT](context) {
        if (VueCookies.isKey('banned')) {
            router.push({
                name: 'errors.banned'
            }).catch((error) => {
            })
        }
    }
}